import { Link } from "@jsq/ds/core";
import { globalEnv } from "~/global-env";
import { RowItem, TypedAGGridCellRenderParams } from "../types";
import { positionLabel, positionLink } from "./styles_vanilla.css";

interface Props {
  params: TypedAGGridCellRenderParams<RowItem>;
}

const buildPositionHref = (positionId: number, arenaId: string, entityId: string) => {
  const searchParams = new URLSearchParams({ positionIds: String(positionId) });
  if (entityId) {
    searchParams.set("entityId", entityId);
  }
  if (arenaId) {
    searchParams.set("arenaIds", arenaId);
  }
  return `${globalEnv.complianceRoute}/positions?${searchParams.toString()}`;
};

const buildPositionLabel = (accountName: string | null, entityName: string | null) => {
  if (accountName && entityName) {
    return `${accountName} in ${entityName}`;
  }
  return accountName || entityName || "View position";
};

export const CasePositionRenderer = ({ params }: Props) => {
  const { positionId, positionAccountName, positionEntityName, clientId, entityId } =
    params.data;
  const canLink = positionId != null;

  if (!canLink) {
    return <>--</>;
  }

  const label = buildPositionLabel(positionAccountName, positionEntityName);

  return (
    <Link
      to={buildPositionHref(positionId, clientId, entityId)}
      shouldOpenInNewTab
      icon="link-horizontal"
      iconPosition="left"
      align="left"
      isInline
      className={positionLink}
    >
      <span className={positionLabel} title={label}>
        {label}
      </span>
    </Link>
  );
};
